import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How fast is the delivery?',
      answer: 'Most orders start within minutes and complete within 24-48 hours depending on the service and quantity. We offer the fastest delivery times in the industry.'
    },
    {
      question: 'Are the services safe for my account?',
      answer: 'Yes, all our services are 100% safe and comply with platform guidelines. We use gradual delivery methods to ensure your account remains secure.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards, PayPal, Bitcoin, and other cryptocurrencies. All payments are processed securely through encrypted channels.'
    },
    {
      question: 'Do you provide refill guarantee?',
      answer: 'Yes, we offer a 30-day refill guarantee on most services. If there\'s any drop in numbers, we\'ll refill them for free within the guarantee period.'
    },
    {
      question: 'Can I track my order progress?',
      answer: 'Absolutely! You can track all your orders in real-time through your dashboard. You\'ll receive notifications for order status updates.'
    },
    {
      question: 'Is there a minimum order requirement?',
      answer: 'No, there\'s no minimum order requirement. You can start with as little as 100 followers or likes and scale up as needed.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Got questions? We've got answers. Here are the most common questions 
            about our services and how we can help grow your social media presence.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
              >
                <span className="font-semibold text-gray-900">{faq.question}</span>
                <SafeIcon 
                  icon={openIndex === index ? FiChevronUp : FiChevronDown} 
                  className="w-5 h-5 text-gray-500" 
                />
              </button>
              
              {openIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  className="px-6 pb-4"
                >
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;